import { render, staticRenderFns } from "./haopinRuku.vue?vue&type=template&id=0e60dee1&scoped=true"
import script from "./haopinRuku.vue?vue&type=script&lang=js"
export * from "./haopinRuku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e60dee1",
  null
  
)

export default component.exports